module.exports = __webpack_public_path__ + "static/media/Item_Back_C_00_Lv3_C.471c68ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Equipment/Backpack/Item_Back_C_00_Lv3_C.png
// module id = 192
// module chunks = 0